/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightObservedItinerary } from "./FlightObservedItinerary";
import {
  FlightObservedItineraryFromJSON,
  FlightObservedItineraryFromJSONTyped,
  FlightObservedItineraryToJSON,
  FlightObservedItineraryToJSONTyped,
} from "./FlightObservedItinerary";
import type { FlightExchangePreparationResponse } from "./FlightExchangePreparationResponse";
import {
  FlightExchangePreparationResponseFromJSON,
  FlightExchangePreparationResponseFromJSONTyped,
  FlightExchangePreparationResponseToJSON,
  FlightExchangePreparationResponseToJSONTyped,
} from "./FlightExchangePreparationResponse";

/**
 *
 * @export
 * @interface FlightExchangeReviewResponse
 */
export interface FlightExchangeReviewResponse {
  /**
   *
   * @type {FlightExchangePreparationResponse}
   * @memberof FlightExchangeReviewResponse
   */
  preparation: FlightExchangePreparationResponse;
  /**
   *
   * @type {FlightObservedItinerary}
   * @memberof FlightExchangeReviewResponse
   */
  original: FlightObservedItinerary | null;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  quoteDigest: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  pricingDisclosureVersion: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  pricingDisclosure: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  selectedPaymentMethodId: string | null;
  /**
   * Server-derived exact quote and owned wallet-revision acknowledgment challenge.
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  consentDigest: string | null;
  /**
   * Stored acknowledgment only; never payment authentication or execution permission.
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  consentStatus: FlightExchangeReviewResponseConsentStatusEnum;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeReviewResponse
   */
  canAcceptConsent: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  reasonCode: string;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReviewResponse
   */
  authenticationStatus: FlightExchangeReviewResponseAuthenticationStatusEnum;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeReviewResponse
   */
  canConfirm: boolean;
}

/**
 * @export
 */
export const FlightExchangeReviewResponseConsentStatusEnum = {
  Unaccepted: "unaccepted",
  Accepted: "accepted",
  Conflict: "conflict",
} as const;
export type FlightExchangeReviewResponseConsentStatusEnum =
  (typeof FlightExchangeReviewResponseConsentStatusEnum)[keyof typeof FlightExchangeReviewResponseConsentStatusEnum];

/**
 * @export
 */
export const FlightExchangeReviewResponseAuthenticationStatusEnum = {
  Unavailable: "unavailable",
} as const;
export type FlightExchangeReviewResponseAuthenticationStatusEnum =
  (typeof FlightExchangeReviewResponseAuthenticationStatusEnum)[keyof typeof FlightExchangeReviewResponseAuthenticationStatusEnum];

/**
 * Check if a given object implements the FlightExchangeReviewResponse interface.
 */
export function instanceOfFlightExchangeReviewResponse(
  value: object
): value is FlightExchangeReviewResponse {
  if (!("preparation" in value) || value["preparation"] === undefined)
    return false;
  if (!("original" in value) || value["original"] === undefined) return false;
  if (!("quoteDigest" in value) || value["quoteDigest"] === undefined)
    return false;
  if (
    !("pricingDisclosureVersion" in value) ||
    value["pricingDisclosureVersion"] === undefined
  )
    return false;
  if (
    !("pricingDisclosure" in value) ||
    value["pricingDisclosure"] === undefined
  )
    return false;
  if (
    !("selectedPaymentMethodId" in value) ||
    value["selectedPaymentMethodId"] === undefined
  )
    return false;
  if (!("consentDigest" in value) || value["consentDigest"] === undefined)
    return false;
  if (!("consentStatus" in value) || value["consentStatus"] === undefined)
    return false;
  if (!("canAcceptConsent" in value) || value["canAcceptConsent"] === undefined)
    return false;
  if (!("reasonCode" in value) || value["reasonCode"] === undefined)
    return false;
  if (
    !("authenticationStatus" in value) ||
    value["authenticationStatus"] === undefined
  )
    return false;
  if (!("canConfirm" in value) || value["canConfirm"] === undefined)
    return false;
  return true;
}

export function FlightExchangeReviewResponseFromJSON(
  json: any
): FlightExchangeReviewResponse {
  return FlightExchangeReviewResponseFromJSONTyped(json, false);
}

export function FlightExchangeReviewResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeReviewResponse {
  if (json == null) {
    return json;
  }
  return {
    preparation: FlightExchangePreparationResponseFromJSON(json["preparation"]),
    original: FlightObservedItineraryFromJSON(json["original"]),
    quoteDigest: json["quote_digest"],
    pricingDisclosureVersion: json["pricing_disclosure_version"],
    pricingDisclosure: json["pricing_disclosure"],
    selectedPaymentMethodId: json["selected_payment_method_id"],
    consentDigest: json["consent_digest"],
    consentStatus: json["consent_status"],
    canAcceptConsent: json["can_accept_consent"],
    reasonCode: json["reason_code"],
    authenticationStatus: json["authentication_status"],
    canConfirm: json["can_confirm"],
  };
}

export function FlightExchangeReviewResponseToJSON(
  json: any
): FlightExchangeReviewResponse {
  return FlightExchangeReviewResponseToJSONTyped(json, false);
}

export function FlightExchangeReviewResponseToJSONTyped(
  value?: FlightExchangeReviewResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    preparation: FlightExchangePreparationResponseToJSON(value["preparation"]),
    original: FlightObservedItineraryToJSON(value["original"]),
    quote_digest: value["quoteDigest"],
    pricing_disclosure_version: value["pricingDisclosureVersion"],
    pricing_disclosure: value["pricingDisclosure"],
    selected_payment_method_id: value["selectedPaymentMethodId"],
    consent_digest: value["consentDigest"],
    consent_status: value["consentStatus"],
    can_accept_consent: value["canAcceptConsent"],
    reason_code: value["reasonCode"],
    authentication_status: value["authenticationStatus"],
    can_confirm: value["canConfirm"],
  };
}
